import { render, staticRenderFns } from "./AutorizadosCompraPrazo.vue?vue&type=template&id=843cfb0a&"
import script from "./AutorizadosCompraPrazo.vue?vue&type=script&lang=js&"
export * from "./AutorizadosCompraPrazo.vue?vue&type=script&lang=js&"
import style0 from "./AutorizadosCompraPrazo.vue?vue&type=style&index=0&id=843cfb0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports